import type { XComponentsAdapter } from '@empathyco/x-types'

import { getSearchEndpointAdapter } from './endpoints/search-endpoint-adapter'

export function getAdapter(endpoints: { search: string }): Partial<XComponentsAdapter> {
  // TODO: fix partial type on X
  return {
    search: getSearchEndpointAdapter(endpoints.search),
  }
}
